import { Div, Icon, Label, Loader, Paragraph } from "@grassrootly/rn-core";
import { ScreenLayout } from "../../layout/components";
import { MainStackScreenProps } from "../../navigation/Navigation.types";
import { useMonthlyStats } from "./useMonthlyStats";
import { Image, ScrollView } from "react-native";
import moment from "moment";
import { images } from "../../layout/assets";

export default function StatsScreen({ navigation }: MainStackScreenProps<"stats">) {
  const { stats, loading, nextMonth, previousMonth, year, month } = useMonthlyStats();

  return (
    <ScreenLayout
      header={{ center: "MONTHLY RANKINGS", left: <Icon name="menu" size={24} onPress={navigation.toggleDrawer} /> }}
    >
      <Div classNames={["flexRow", "justifyContentSpaceBetween"]}>
        <Div classNames={["flexColumn"]}>
          <Icon name="arrow_back_ios" size={30} onPress={previousMonth} />
        </Div>
        <Div classNames={["flexColumn"]}>
          <Paragraph classNames={["b1Regular", "mt-{5}"]}>
            {moment(month, "MM").format("MMMM")} {year}
          </Paragraph>
        </Div>
        <Div classNames={["flexColumn"]}>
          <Icon name="arrow_forward_ios" size={30} onPress={nextMonth} />
        </Div>
      </Div>
      {loading ? (
        <Div classNames={["mt-{30}"]}>
          <Loader size="large" isLoading />
        </Div>
      ) : null}
      {!loading && stats && !stats.players.length ? (
        <Label type="l1Bold" classNames={["textCenter", "colorSecondaryLight", "mt-{30}"]}>
          Rankings not found
        </Label>
      ) : null}
      {!loading && stats && stats.players && (
        <ScrollView>
          <Div classNames={["flex1"]}>
            {stats && stats.players
              ? stats.players.map((p, index) => (
                  <Div
                    key={p.name}
                    classNames={["p16", index % 2 !== 0 ? "bgSecondaryMain" : "", "flexRow", "alignItemsCenter"]}
                  >
                    <Div classNames={["flex1"]}>
                      <Div classNames={["flexRow", "alignItemsCenter"]}>
                        <Image
                          style={{ height: 40, width: 40, borderRadius: 40 }}
                          resizeMode="cover"
                          source={p.profile_picture ? { uri: p.profile_picture } : images.playerAvatar}
                        />
                        <Div classNames={["ml-{15}", "flex1"]}>
                          <Label numberOfLines={1} ellipsizeMode="tail">
                            {p.name}
                          </Label>
                        </Div>
                        <Div classNames={["ml-{auto}", "flexRow", "alignContentCenter"]}>
                          <Label>Experience Pts: {p.points}</Label>
                        </Div>
                      </Div>
                    </Div>
                  </Div>
                ))
              : null}
          </Div>
        </ScrollView>
      )}
    </ScreenLayout>
  );
}
